import React from "react";
import { useQuery } from "@apollo/client";
import { FIND_ALL_FRAUDS_QUERY } from "../../Queries";
import { Fraud } from "../../generated/graphql";
import FraudNotice from "./FraudNotice";

const FraudAboveSignature = () => {
    const { data: fraudsData } = useQuery(FIND_ALL_FRAUDS_QUERY)

    const frauds = fraudsData?.findAllFrauds as Fraud[]
    return <div id="fraud-above-signature" className="flex-gap">
        {frauds?.filter(fraud => fraud.aboveSignature)?.map(fraud =>
            <FraudNotice fraud={fraud}/>
        )}
    </div>
}

export default FraudAboveSignature;
